module.exports = __webpack_public_path__ + "static/img/step2_1.9ba7035.png";


//////////////////
// WEBPACK FOOTER
// ./static/funding_cpunk/creation/step2_1.png
// module id = hwWR
// module chunks = 1